/** @module components/FolderBox */
import { Spin } from "react-aiot";
import { resolveIcon } from "../util";
import React from "react";
export function FolderBoxHeader({
  icon,
  folder
}) {
  return /*#__PURE__*/React.createElement("span", null, icon, " ", resolveIcon(folder.icon), " ", folder.title);
}
/**
 * A component showing a container for a folder option. For example the metabox
 * or manual placement for nodes (rearrange).
 */

export default function ({
  busy,
  icon,
  folder,
  errors = [],
  header = true,
  children
}) {
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy === undefined ? false : busy,
    size: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rml-postbox"
  }, header && /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(FolderBoxHeader, {
    icon: icon,
    folder: folder
  })), errors.length > 0 && /*#__PURE__*/React.createElement("ul", {
    style: {
      marginTop: 0
    }
  }, errors.map((e, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, e))), children && /*#__PURE__*/React.createElement("div", {
    className: "inside"
  }, children), folder.id > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      float: "right",
      paddingBottom: "5px",
      fontSize: "10px",
      opacity: 0.5
    }
  }, "ID #", folder.id)));
}